export const formatPrice = (n?: number | null): string =>
  n == null ? "POA" : "R " + n.toLocaleString("en-ZA").replace(/,/g, " ");

export const formatKm = (n?: number | null): string =>
  n == null ? "—" : n.toLocaleString("en-ZA").replace(/,/g, " ") + " km";
